import { render } from "./SmsSettingsPage.vue?vue&type=template&id=5b834c7c&ts=true"
import script from "./SmsSettingsPage.vue?vue&type=script&lang=ts"
export * from "./SmsSettingsPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__